import { reactive } from "vue"

export const alertStore = reactive({
  show: false,
  type: "success",
  title: "",
  message: "",

  trigger(type, title, message) {
    this.type = type
    this.title = title
    this.message = message
    this.show = true
  },

  close() {
    this.show = false
  }
})
